import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './CompanyNameCombine.scss';
import CargoTypeSelectorApi from '../CargoTypeSelector/api/CargoTypeSelectorApi';
import BaseResponse from '../../app/BaseResponse';
import CargoTypeModel from '../CargoTypeSelector/models/CargoTypeModel';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import _ from 'lodash';
import CompanyNameCombineInput from './CompanyNameCombineInput';
import CompanyNameCombineTable from './CompanyNameCombineTable';

let triggerHotkeyAlready = false;

const CompanyNameCombine: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "CompanyNameCombine";

    }, []);

    return (
        <>
            <Grid container>
                <Grid item lg={12} xs={12}>
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <CompanyNameCombineInput></CompanyNameCombineInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <CompanyNameCombineTable></CompanyNameCombineTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default CompanyNameCombine;